class EngravingSimulator {

    constructor() {
        this.appUrl = 'https://cft-conf2020.s3.amazonaws.com/dist';
    }

    setAppUrl(newAppUrl) {
        if (typeof newAppUrl === 'string' && newAppUrl !== '' && newAppUrl.substr(0, 8) === 'https://') {
            this.appUrl = newAppUrl;
        }
    }

    getAsHtml(text) {
        if (typeof text !== 'string') {
            console.error('invalid text. Must be a string', text)
        } else {
            if (text === '') {
                text = "&nbsp;";
            }

            let textParts = text.split(" ");
            if (textParts.length > 0) {
                text = "";
                for (let i in textParts) {
                    text += textParts[i].trim();

                    let nextTextPart = textParts[(parseInt(i) + 1)];
                    if (nextTextPart) {
                        nextTextPart = nextTextPart.trim();
                        if ((textParts[i].indexOf('#S14') > - 1 && nextTextPart.indexOf('#S') < 0 ) ||
                            (nextTextPart.indexOf('#S14') > - 1 && textParts[i].indexOf('#S') < 0) ||
                            (nextTextPart.indexOf('#S') < 0 && textParts[i].indexOf('#S') < 0)
                        ) {
                            text += ' ';
                        }
                    }
                }
            }

            let url = this.appUrl + '/engraving/symbols/';
            text = text.replace(
              /#S([0-9]{1,2})/g,
              '<img src="' +
                url +
                "S$1" +
                '.svg" style="height: 1.5em; display: inline-block; margin-top: -0.5rem;S$1" alt="S$1"/>'
            );

            text = text.replace(';S14', '; margin: 0 1rem');
            text = text.replace(/;S([0-9]{1,2})/g, ';');
            return text;
        }
    }

    getCssClassByFontId(fontId) {
        if (typeof fontId === 'number' && fontId > 0) {
            return 'font-' + fontId;
        } else {
            console.error('invalid font id type', fontId)
        }
    }
}

export default new EngravingSimulator();
